import React from 'react';
import { Wrapper } from './Placeholders.styles';

export function Placeholders() {
    const opacity = [0.02, 0.04, 0.06, 0.08, 0.1, 0.12, 0.14, 0.16, 0.18, 0.2];
    return (
        <>
            {opacity.map((el: any) => (
                <Wrapper key={el} opacity={el}></Wrapper>
            ))}
        </>
    )
}
